import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
} from '@mui/material';

export type PreviewData = {
  missionName: string;
  boxes: {
    uid: string;
    closed: boolean;
    samplesNumber: number;
  }[];
} | null;

interface DatabasePreviewProps {
  open: boolean;
  onClose: () => void;
  data: PreviewData;
}

const DatabasePreview: React.FC<DatabasePreviewProps> = ({ open, onClose, data }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Database Preview</DialogTitle>

      <DialogContent dividers>
        {data ? (
          <>
            <Typography variant="h6" gutterBottom>
              Mission: {data.missionName}
            </Typography>

            <Box mt={2}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Box UID</TableCell>
                    <TableCell>Closed</TableCell>
                    <TableCell align="right">Samples</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.boxes.map((box) => (
                    <TableRow key={box.uid}>
                      <TableCell>{box.uid}</TableCell>
                      <TableCell>{box.closed ? 'Yes' : 'No'}</TableCell>
                      <TableCell align="right">{box.samplesNumber}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </>
        ) : (
          <Typography color="textSecondary">No data to display</Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary" variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DatabasePreview;
